import { $_WC } from '@/confs/common.const';

export default class GripGeoJsonSimpleMap {

    constructor(elId) {
        this._Svg = undefined;

        // 지도 영역 path
        this._PathG = undefined;
        this._PathMap = {};
        // 지역명 text
        this._DefaultTextG = undefined;
        this._DefaultTextMap = {};

        // 추가 text
        this._ValueTextG = undefined;
        this._ValueTextMap = {};

        // 원차트
        this._CircleGMap = {};

        // text 차트
        this._TextGMap = {};

        this._ChartGMap = {};

        // 컬럼 차트
        this._ColumnChartGMap = {};

        this._PolylineGMap = {};
        this._PolylineMap = {};

        this._PolygonGMap = {};
        this._PolygonMap = {};

        // 마커
        this._MarkGMap = {};

        // defs
        this._Defs = {};

        this._Id = elId;

        if(elId && elId.length > 0) {
            if(elId.charAt(0) !==  "#") {
                elId = "#" + elId;
            }
        } else {
            elId = "";
        }

        this.elId = elId;
        this.el = d3.select(elId)._groups[0][0];

        // 너비와 높이 기본 값 설정
        if(typeof this.el === undefined) {
            this.width = 0;
            this.height = 0;
        } else {
            this.width = this.el.offsetWidth;
            this.height = this.el.offsetHeight;
        }

        this._Projection = d3.geoMercator().translate([this.width / 2, this.height / 2]);
        this._GeoPath = d3.geoPath().projection(this._Projection);

        this.geoJsonUrl = "";
        this.mapScale = 1;
        this.center = undefined;
        this.viewScale = (window.innerWidth / 1920);
        this.features = undefined;

        // 지역 코드 필드 명
        this.keyPropNm;
        // 지역명 key 필드 명
        this.namePropNm;

        // 그리기 완료 이벤트
        this.mapDrawCompletedHandler;

        // path 클릭 이벤트
        this.pathClickHandler;

        // 외곽선 색상
        // this.pathStrokeColor = "rgb(206,206,206)";
        this.pathStrokeColor = "rgb(150,150,150)";

        this.pathDefaultColor = "rgb(46,46,46)";

        // 외곽선 굵기
        if($_WC.responsiveScale === 3){
            this.pathStrokeWidth = 2;
        } else {
            this.pathStrokeWidth = 1;
        }
        this.pathStrokeWidth = this.pathStrokeWidth * $_WC.viewScale;
        this.pathOpacity = 0.8;
    }

    // 지도 그리기
    drawMap() {
        let $vm = this;

        if(this.el) {
            // 모든 영역을 지운다
            this.el.innerHTML = "";

            // svg 영역 생성
            this._Svg = d3.select(this.elId).append("svg")
                .attr("id", "svg-" + this._Id)
                .attr("width", this.width)
                .attr("height", this.height);

            d3.json(this.geoJsonUrl, (err, json) => {
                let bounds = d3.geoBounds(json);
                if(typeof this.center === 'undefined') {
                    this.center = d3.geoCentroid(json);
                }
                let distance = d3.geoDistance(bounds[0], bounds[1]);
                let scale = this.height * this.mapScale * 1.5 / distance / Math.sqrt(2);
                this._Projection.scale(scale).center(this.center);
                this.features = json.features;

                // 지도 영역 그리기
                this._PathG = this._Svg.append("g");
                this._PathG.selectAll("path")
                    .data(json.features)
                    .enter()
                    .append("path")
                    .attr("d", this._GeoPath)
                    .attr("fill", this.pathDefaultColor)
                    .style("opacity", this.pathOpacity)
                    .style("stroke", this.pathStrokeColor)
                    .style("stroke-width", this.pathStrokeWidth)
                    .on('click', data => {
                        if(typeof this.pathClickHandler === 'function') {
                            this.pathClickHandler(data.properties[this.keyPropNm], unescape(data.properties[this.namePropNm]), false);
                        }
                    })
                    .each(function(data, j) {
                        //console.log(data.properties[$vm.keyPropNm] + " : " + unescape(data.properties[$vm.namePropNm]));
                        $vm._PathMap["p_" + data.properties[$vm.keyPropNm]] = this;
                    });

                // this._PathG.call(d3.zoom().on("zoom", () => {
                //        this.moveSimpleMap();
                // }));

                // 지역명 설정
                this._DefaultTextG = this._Svg.append("g").style("display", "none");
                this._DefaultTextG.selectAll("text")
                    .data(json.features)
                    .enter()
                    .append("text")
                    .attr("transform", d => {
                        // 영역의 중심에 표시
                        return "translate(" + this._GeoPath.centroid(d) + ")";
                    })
                    .attr("dy", ".35em")
                    .attr("class", d => {
                        return "municipality-label geocode-" + d.properties[this.keyPropNm];
                    })
                    .text(d => {
                        return unescape(d.properties[this.namePropNm]);
                    })
                    .on('click', data => {
                        if(typeof this.pathClickHandler === 'function') {
                            this.pathClickHandler(data.properties[this.keyPropNm], unescape(data.properties[this.namePropNm]), true);
                        }
                    })
                    .each(function(data) {
                        $vm._DefaultTextMap["t_" + data.properties[$vm.keyPropNm]] = this;
                    });

                // 추가 텍스트 영역 설정
                this._ValueTextG = this._Svg.append("g").style("display", "none");
                this._ValueTextG.selectAll("text")
                    .data(json.features)
                    .enter()
                    .append("text")
                    .attr("transform", d => {
                        // 영역의 중심에 표시
                        let centroid = this._GeoPath.centroid(d);
                        centroid[0] = centroid[0] - (this.viewScale * 8);
                        centroid[1] = centroid[1] - (this.viewScale * 5);
                        return "translate(" + centroid + ")";
                    })
                    .attr("dy", ".35em")
                    .attr("class", d => {
                        return "municipality-label geocode-" + d.properties[this.keyPropNm];
                    })
                    .text(d => {
                        return unescape(d.properties[this.namePropNm]);
                    })
                    .append("tspan")
                    .attr("dx", "-5.0%")
                    .attr("dy", "2.8%")
                    .style("fill", "#fff")
                    .each(function(data) {
                        $vm._ValueTextMap["v_t_" + data.properties[$vm.keyPropNm]] = this;
                    });

                // defs 정의
                this._Defs = this._Svg.append("defs");
                // 화살표 marker 생성
                this._Defs.append("marker")
                    .attr("id", this._Id + "-defs-arrow")
                    .attr("refX", 5)
                    .attr("refY", 5)
                    .attr("markerWidth", 2)
                    .attr("markerHeight", 2)
                    .attr("orient", "auto-start-reverse")
                    .append("path")
                    .attr("d", "M 0 0 L 10 5 L 0 10 z");

                // 지도 그리기 완료
                if(typeof this.mapDrawCompletedHandler === 'function') {
                    this.mapDrawCompletedHandler();
                }
            });
        }
    }

    // moveSimpleMap(orgCenter, center, scale) {
    //     this._PathG.attr("transform", d3.event.transform);
    //     this._ValueTextG.attr("transform", d3.event.transform);
    //     this._DefaultTextG.attr("transform", d3.event.transform);
    //     for(let key in this._MarkGMap) {
    //         this._MarkGMap[key].attr("transform", d3.event.transform);
    //     }
    //     for(let key in this._TextGMap) {
    //         this._TextGMap[key].attr("transform", d3.event.transform);
    //     }
    //     for(let key in this._ChartGMap) {
    //         this._ChartGMap[key].attr("transform", d3.event.transform);
    //     }
    //     for(let key in this._PolylineGMap) {
    //         this._PolylineGMap[key].attr("transform", d3.event.transform);
    //     }
    //     for(let key in this._PolygonGMap) {
    //         this._PolygonGMap[key].attr("transform", d3.event.transform);
    //     }
    //     for(let key in this._CircleGMap) {
    //         this._CircleGMap[key].attr("transform", d3.event.transform);
    //     }
    // };

    // 마커 추가
    addMarker(markerGroupName, lat, lng, imgUrl, width = 40, height = 40) {
        if(!lat || !lng || lat === 'null' || lng === 'null') {
            return null;
        }

        if(typeof this._MarkGMap[markerGroupName] === 'undefined') {
            this._MarkGMap[markerGroupName] = this._Svg.append("g").attr("id", this._Id + "-marker-" + markerGroupName);
        }

        let loc = this._Projection([lng, lat]);

        let marker = this._MarkGMap[markerGroupName].append("svg:image")
            .attr("xlink:href", imgUrl)
            .attr("width", width)
            .attr("height", height)
            .attr("class", "simple_marker")
            .attr("transform", function(d) {
                let width = this.getAttribute("width");
                let height = this.getAttribute("height");
                return "translate(" + [loc[0] - (width / 2), loc[1] - height] + ")";
            });

        marker.x = loc[0];
        marker.y = loc[1];
        return marker;
    }
    showMarkerGroup(groupName, isShow) {
        if(isShow) {
            this._MarkGMap[groupName].style("display", "");
        } else {
            this._MarkGMap[groupName].style("display", "none");
        }
    }

    removeMarkerGroup(markerGroupName) {
        if(typeof this._MarkGMap[markerGroupName] !== 'undefined') {
            this._MarkGMap[markerGroupName].remove();
        }

        delete this._MarkGMap[markerGroupName];
    }

    removeAllMarkerGroup() {
        for(let groupName in this._MarkGMap) {
            this.removeMarkerGroup(groupName);
        }
    }

    addPolygon = function(keyType, key, geoJsonUrl, color, opacity, clickHandle, mapKey) {
        let $vm = this;
        let groupName = key;
        if(typeof mapKey === 'undefined') {
            mapKey = groupName;
        }
        d3.json(geoJsonUrl, function(err, geoJson) {
            geoJson.features.forEach(function(feature, idx){
                if(keyType === 'prop') {
                    let prop = feature.properties;
                    groupName = prop[key];
                }
                if(typeof $vm._PolygonGMap[mapKey] === 'undefined') {
                    $vm._PolygonGMap[mapKey] = $vm._Svg.append("g").attr("id", $vm._Id + "-polygon-" + mapKey);
                }

                if(typeof $vm._PolygonMap[mapKey] === 'undefined') {
                    $vm._PolygonMap[mapKey] = [];
                }

                let coordinates = feature.geometry.coordinates;
                if(typeof coordinates !== 'undefined' && coordinates.length) {
                    let locs = [];
                    coordinates.forEach(function(coordinate) {
                        coordinate.forEach(function(coords){
                            coords.forEach(function(d) {
                                let x = d[0];
                                let y = d[1];
                                locs.push($vm._Projection([x, y]));
                            });
                        });
                    });

                    let fill = color;
                    if(Array.isArray(color)) {
                        fill = typeof color[groupName] !== 'undefined' ? color[groupName] : '';
                    }

                    let polygon = $vm._PolygonGMap[mapKey].append("polygon")
                        .attr("points", locs.join(" "))
                        .attr("stroke", 'none')
                        .attr("fill", fill)
                        .style("fill-opacity", opacity)
                        .on('click', function() {
                            if(typeof clickHandle === 'function') {
                                clickHandle(groupName);
                            }
                        });

                    $vm._PolygonMap[mapKey].push(polygon);

                    return polygon;
                }
            }.bind(this));
        }.bind(this));
    }

    addPolyline = function(keyType, key, geoJsonUrl, color, strokeWidth, opacity, clickHandle, mapKey) {
        let $vm = this;
        let groupName = key;
        if(typeof mapKey === 'undefined') {
            mapKey = groupName;
        }
        d3.json(geoJsonUrl, function(err, geoJson) {
            let newFeatures = [];
            if(geoJson.type === 'Feature') {
                newFeatures[0] = geoJson;
            } else {
                // FeatureCollection 등
                newFeatures = geoJson.features;
            }

            newFeatures.forEach(function(feature, idx){
                if(keyType === 'prop') {
                    let prop = feature.properties;
                    groupName = prop[key];
                }

                if(typeof $vm._PolylineGMap[mapKey] === 'undefined') {
                    $vm._PolylineGMap[mapKey] = $vm._Svg.append("g").attr("id", $vm._Id + "-polyline-" + mapKey);
                }

                if(typeof $vm._PolylineMap[mapKey] === 'undefined') {
                    $vm._PolylineMap[mapKey] = [];
                }

                let geometryType = feature.geometry.type;
                let coordinates = [];

                if(geometryType === 'LineString') {
                    coordinates[0] = feature.geometry.coordinates;
                } else {
                    // MultiLineString
                    coordinates = feature.geometry.coordinates;
                }

                if(typeof coordinates !== 'undefined' && coordinates.length) {
                    let locs = [];
                    coordinates.forEach(function(paths) {
                        paths.forEach(function(path) {
                            let x = path[0];
                            let y = path[1];
                            locs.push($vm._Projection([x, y]));
                        });
                    }.bind(this));

                    let fill = color;
                    if(Array.isArray(color)) {
                        fill = typeof color[groupName] !== 'undefined' ? color[groupName] : '';
                    }

                    let polyline = $vm._PolylineGMap[mapKey].append("polyline")
                        .attr("points", locs.join(" "))
                        .attr("stroke", fill)
                        .attr("stroke-width", strokeWidth)
                        .style("opacity", opacity)
                        .attr("fill", "none")
                        .on('click', function() {
                            if(typeof clickHandle === 'function') {
                                clickHandle(groupName);
                            }
                        });
                    $vm._PolylineMap[mapKey].push(polyline);

                    return polyline;
                }
            }.bind(this));
        }.bind(this));
    }

    addChart = function(groupName, lat, lng, colors, data, maxVal, height, showOverText) {
        let $vm = this;

        let loc = $vm._Projection([lng, lat]);
        let colWidth = 5 * $_WC.viewScale;
        let colHeight = 30 * $_WC.viewScale;
        let colSpace = 1 * $_WC.viewScale;

        let yScale = d3.scaleLinear().domain([0, maxVal]).range([0, colHeight]).clamp(true);

        let totalWidth = (colWidth * data.length) + (colSpace * (data.length - 1));

        if(typeof this._ChartGMap[groupName] === 'undefined') {
            this._ChartGMap[groupName] = this._Svg.append("g").attr("id", this.elId + "-chart-" + groupName);
        }

        if(typeof height === 'undefined') {
            height = 0;
        } else {
            height = height * -1 * $_WC.viewScale;
        }

        let chartG = this._ChartGMap[groupName].append("g");
        chartG.attr("transform", function() {
            return "translate(" + loc + ")";
        });

        chartG.selectAll("rect")
            .data(data)
            .enter()
            .append("rect")
            .attr("width", colWidth)
            .attr("height", function(d){ return yScale(d); })
            .style("fill", function(d, i){ return colors[i]; })
            .attr("x", function(d, i){ return i * (colWidth + colSpace) - (totalWidth / 2); })
            .attr("y", function(d){ return (yScale(d) * -1) + height; });

        if(typeof showOverText !== 'undefined' && showOverText === true) {
            data.forEach(function(d, i){
                if(Number(d) > Number(maxVal)) {
                    let x = i * (colWidth + colSpace) - (totalWidth / 2);
                    let y = (yScale(d) * -1) + height;

                    chartG.append("text")
                        .attr("font-size", 9 * $_WC.viewScale)
                        .attr("fill", "#fff")
                        .text("+")
                        .attr("x", x)
                        .attr("y", y);
                }
            });
        }
        return chartG;
    }

    addBoxChart = function(groupName, lat, lng, colors, data, maxVal, height, showOverText) {
        let scale = 1;
        if($_WC.responsiveScale === 3){
            scale = 1.6;
        }
        scale = scale * $_WC.viewScale;

        let loc = this._Projection([lng, lat]);
        let colWidth = 5 * scale;
//            let colHeight = 30 * scale;
        let colHeight = height * maxVal * scale;
        let colSpace = 1 * scale;
        height = height * scale;

        let yScale = d3.scaleLinear().domain([0, maxVal]).range([0, colHeight]).clamp(true);

        let totalWidth = (colWidth * data.length) + (colSpace * (data.length - 1));

        if(typeof this._ChartGMap[groupName] === 'undefined') {
            this._ChartGMap[groupName] = this._Svg.append("g").attr("id", this.elId + "-chart-" + groupName);
        }

        let chartG = this._ChartGMap[groupName].append("g");
        chartG.attr("transform", function() {
            return "translate(" + loc + ")";
        });

        data.forEach(function(val, index){
            for(var i = 0; i < Number(val); i++) {
                if(i >= Number(maxVal)) {
                    break;
                }
                let y = (-11 * scale) - (i * (height + scale));

                chartG.append("rect")
                    .attr("width", colWidth)
                    .attr("height", height)
                    .style("fill", colors[index])
                    .attr("x", index * (colWidth + colSpace) - (totalWidth / 2))
                    .attr("y", y);
            }
        });

        if(typeof showOverText !== 'undefined' && showOverText === true) {
            data.forEach(function(d, i){
                if(Number(d) > Number(maxVal)) {
                    let x = i * (colWidth + colSpace) - (totalWidth / 2);
                    let y = (-11 * scale) - colHeight;

                    chartG.append("text")
                        .attr("font-size", 9 * scale)
                        .attr("fill", "#fff")
                        .text("+")
                        .attr("x", x)
                        .attr("y", y);
                }
            });
        }
        return chartG;
    }

    addBgBoxChart = function(groupName, lat, lng, colors, data, maxVal, height, showOverText) {
        let scale = 1;
        if($_WC.responsiveScale === 3){
            scale = 1.6;
        }
        scale = scale * $_WC.viewScale;
        let loc = this._Projection([lng, lat]);
        let colWidth = height * scale;
//            let colHeight = 30 * scale;
        let colHeight = height * maxVal * scale;
        let colSpace = 1 * scale;
        height = height * scale;

        let yScale = d3.scaleLinear().domain([0, maxVal]).range([0, colHeight]).clamp(true);

        let totalWidth = (colWidth * data.length) + (colSpace * (data.length - 1));

        if(typeof this._ChartGMap[groupName] === 'undefined') {
            this._ChartGMap[groupName] = this._Svg.append("g").attr("id", this.elId + "-chart-" + groupName);
        }

        let chartG = this._ChartGMap[groupName].append("g");
        chartG.attr("transform", function() {
            return "translate(" + loc + ")";
        });

        // 배경
        data.forEach((val, index)=>{
            for(let i = 0; i < Number(maxVal); i++) {
                let y = (-11 * scale) - (i * (height + scale));
                chartG.append("rect")
                    .attr("width", colWidth)
                    .attr("height", height)
                    .style("fill", '#555555')
                    .style("stroke", '#222222')
                    .style("stroke-width", 0.4)
                    .attr("x", index * (colWidth + colSpace) - (totalWidth / 2))
                    .attr("y", y);
            }
        });

        // 실제 데이터
        data.forEach((val, index)=>{
            for(let i = 0; i < Number(val); i++) {
                if(i >= Number(maxVal)) {
                    break;
                }
                let y = (-11 * scale) - (i * (height + scale));
                chartG.append("rect")
                    .attr("width", colWidth)
                    .attr("height", height)
                    .style("fill", colors[index])
                    .attr("x", index * (colWidth + colSpace) - (totalWidth / 2))
                    .attr("y", y);
            }
        });

        if(typeof showOverText !== 'undefined' && showOverText === true) {
            data.forEach((d, index)=>{
                if(Number(d) > Number(maxVal)) {
                    let i = Number(maxVal) - 2;
                    let y = (-11 * scale) - (i * (height + scale));
                    let fontSize = (colWidth + (colWidth - (3 * scale)));
                    y = y - scale;

                    chartG.append("text")
                        .attr("font-size", fontSize)
                        .attr("fill", "#fff")
                        .text("+")
                        .attr("x", index * (colWidth + colSpace) - (totalWidth / 2))
                        .attr("y", y);
                }
            });
        }
        return chartG;
    }

    // 컬럼 차트를 추가 한다.
    addColumnChart(groupName, lat, lng, colors, data, maxVal, height) {
        let loc = this._Projection([lng, lat]);
        let colWidth = 5 * this.viewScale;
        let colHeight = 30 * this.viewScale;
        let colSpace = 1 * this.viewScale;

        let yScale = d3.scaleLinear().domain([0, maxVal]).range([0, colHeight]);
        let totalWidth = (colWidth * data.length) + (colSpace * (data.length - 1));

        if(typeof this._ColumnChartGMap[groupName] === 'undefined') {
            this._ColumnChartGMap[groupName] = this._Svg.append("g").attr("id", this.elId + "-chart-" + groupName);
        }

        if(typeof height === 'undefined') {
            height = 0;
        } else {
            height = height * -1 * this.viewScale;
        }

        let chartG = this._ColumnChartGMap[groupName].append("g");
        chartG.attr("transform", function() {
            return "translate(" + loc + ")";
        });

        chartG.selectAll("rect")
            .data(data)
            .enter()
            .append("rect")
            .attr("width", colWidth)
            .attr("height", d => { return yScale(d); })
            .style("fill", (d, i) => { return colors[i]; })
            .attr("x", (d, i) => { return i * (colWidth + colSpace) - (totalWidth / 2); })
            .attr("y", d => { return (yScale(d) * -1) + height; });

        return chartG;
    }

    showColumnChartGroup(groupName, isShow) {
        if(isShow) {
            this._ColumnChartGMap[groupName].style("display", "");
        } else {
            this._ColumnChartGMap[groupName].style("display", "none");
        }
    }

    removeColumnChartGroup(groupName) {
        if(typeof this._ColumnChartGMap[groupName] !== 'undefined') {
            this._ColumnChartGMap[groupName].remove();
        }
        delete this._ColumnChartGMap[groupName];
    }

    removeChartGroup(groupName) {
        if(typeof this._ChartGMap[groupName] !== 'undefined') {
            this._ChartGMap[groupName].remove();
        }
        delete this._ChartGMap[groupName];
    }

    removeAllChartGroup() {
        for(let groupName in this._ChartGMap) {
            this.removeChartGroup(groupName);
        }
    }

    // 서클 추가
    makeCirCle = function(groupName){
        let $vm = this;
        if(typeof $vm._CircleGMap[groupName] === 'undefined') {
            $vm._CircleGMap[groupName] = $vm._Svg.append("g").attr("id", $vm._Id + "-circle-" + groupName);
        }
    }

    addCirCle = function(groupName, lat, lng, size, fill, opacity, cursor) {
        let $vm = this;
        let loc = $vm._Projection([lng, lat]);
        if(typeof $vm._CircleGMap[groupName] === 'undefined') {
            $vm._CircleGMap[groupName] = $vm._Svg.append("g").attr("id", $vm._Id + "-circle-" + groupName);
        }
        let cursorOpt = "default";
        if(typeof cursor !== 'undefined') {
            cursorOpt = cursor;
        }

        let chartG = $vm._CircleGMap[groupName].append("g");
        chartG.attr("transform", function() {
            return "translate(" + loc + ")";
        });

        let r = size;
        if($_WC.responsiveScale === 3){
            r = size * 1.2;
        }
        r = r * $_WC.viewScale;

        chartG.selectAll("circle")
            .data([0])
            .enter()
            .append("circle")
            .attr("r", r)
            .style("fill", fill)
            .style("fill-opacity", opacity)
            .style("cursor", cursorOpt)
            .attr("x", function(d){ return loc[0]; })
            .attr("y", function(d){ return loc[1]; });

        return chartG;
    }

    showCircleGroup(groupName, isShow) {
        if(isShow) {
            this._CircleGMap[groupName].style("display", "");
        } else {
            this._CircleGMap[groupName].style("display", "none");
        }
    }

    removeCircleGroup(groupName) {
        if(typeof this._CircleGMap[groupName] !== 'undefined') {
            this._CircleGMap[groupName].remove();
        }
        delete this._CircleGMap[groupName];
    }

    removeAllCircleGroup() {
        for(let groupName in this._CircleGMap) {
            this.removeCircleGroup(groupName);
        }
    }

    // 텍스트를 추가한다.
    addText = function(groupName, lat, lng, size, color, text, textDy, letterSpacing, cursor, clickHandle) {
        let $vm = this;
        let loc = $vm._Projection([lng, lat]);

        let culSize = 0;
        if(Array.isArray(size)) {
            size.forEach(function(d, index){
                size[index] = $_WC.viewScale * d;
                culSize += size[index];
            });
        } else {
            size = $_WC.viewScale * size;
            culSize = size;
        }
        let cursorOpt = "";
        if(typeof cursor !== 'undefined') {
            cursorOpt = cursor;
        }
        if(typeof $vm._TextGMap[groupName] === 'undefined') {
            $vm._TextGMap[groupName] = $vm._Svg.append("g").attr("id", $vm._Id + "-text-" + groupName);
        }

        let chartG = $vm._TextGMap[groupName].append("g");
        chartG.attr("transform", function() {
//                return "translate(" + loc + ")";
            return "translate(" + [loc[0], loc[1] + (culSize / 2)] + ")";
        });

        if(Array.isArray(text)) {
            var length = text.length;
            text.forEach(function(val, index){
                let dy = (index - length) + (length / 2) + 0.6;
                if(typeof textDy !== 'undefined') {
                    dy += textDy;
                }
                let textSize = size;
                let textColor = color;
                if(Array.isArray(size)) {
                    textSize = size[index];
                }
                if(Array.isArray(color)) {
                    textColor = color[index];
                }
                if(typeof letterSpacing !== 'undefined' && index > 0) {
                    dy += (letterSpacing * index);
                }
                chartG.append("text")
                    .attr("font-size", textSize)
                    // .attr("font-weight", 100)
                    .attr("text-anchor", "middle")
                    .attr("fill", textColor)
                    .attr("dy", dy+"em")
                    .style("cursor", cursorOpt)
                    .text(val)
                    .on('click', function(data) {
                        if(typeof clickHandle === 'function') {
                            clickHandle(text);
                        }
                    });
            });
        } else {
            let dy = 0;
            if(typeof textDy !== 'undefined') {
                dy += textDy;
            }
            chartG.append("text")
                .attr("font-size", size)
                // .attr("font-weight", 100)
                .attr("text-anchor", "middle")
                .attr("fill", color)
                .attr("dy", dy+"em")
                .style("cursor", cursorOpt)
                .text(text)
                .on('click', function(data) {
                    if(typeof clickHandle === 'function') {
                        clickHandle(text);
                    }
                });
        }

        return chartG;
    }

    addEllipse = function(groupName, lat, lng, rx, ry, cx, cy, fill, opacity) {
        let $vm = this;
        let loc = $vm._Projection([lng, lat]);
        if(typeof $vm._CircleGMap[groupName] === 'undefined') {
            $vm._CircleGMap[groupName] = $vm._Svg.append("g").attr("id", $vm._Id + "-ellipse-" + groupName);
        }
        let chartG = $vm._CircleGMap[groupName].append("g");
        chartG.attr("transform", function() {
            return "translate(" + loc + ")";
        });

        chartG.selectAll("ellipse")
            .data([""])
            .enter()
            .append("ellipse")
            .style("fill", fill)
            .style("fill-opacity", opacity)
            .attr("cx", cx * $_WC.viewScale)
            .attr("cy", cy * $_WC.viewScale)
            .attr("rx", rx * $_WC.viewScale)
            .attr("ry", ry * $_WC.viewScale)
        ;

        return chartG;
    }

    addRect = function(groupName, lat, lng, length, fill, opacity, size, cursor) {
        let $vm = this;
        let loc = $vm._Projection([lng, lat]);
        if(typeof $vm._CircleGMap[groupName] === 'undefined') {
            $vm._CircleGMap[groupName] = $vm._Svg.append("g").attr("id", $vm._Id + "-rect-" + groupName);
        }
        let chartG = $vm._CircleGMap[groupName].append("g");
        chartG.attr("transform", function() {
            return "translate(" + loc + ")";
        });

        let cursorOpt = "default";
        if(typeof cursor !== 'undefined') {
            cursorOpt = cursor;
        }

        size = size * 1.4;
        let width = size * length * $_WC.viewScale;
        let height = size * $_WC.viewScale;
        let x = (width / 2) * -1;
        let y = ((height / 2) * -1) + (2 * $_WC.viewScale);

        let rx = 2 * $_WC.viewScale;
        let ry = 2 * $_WC.viewScale;

        chartG.selectAll("rect")
            .data([0])
            .enter()
            .append("rect")
            .style("fill", fill)
            .style("fill-opacity", opacity)
            .style("stroke", 1)
            .style("stroke-width", 1)
            .style("width", width)
            .style("height", height)
            .style("cursor", cursorOpt)
            .attr("x", x)
            .attr("y", y)
            .attr("rx", rx)
            .attr("ry", ry)
        ;

        return chartG;
    }

    showTextGroup(groupName, isShow) {
        if(isShow) {
            this._TextGMap[groupName].style("display", "");
        } else {
            this._TextGMap[groupName].style("display", "none");
        }
    }

    removeTextGroup(groupName) {
        if(typeof this._TextGMap[groupName] !== 'undefined') {
            this._TextGMap[groupName].remove();
        }
        delete this._TextGMap[groupName];
    }

    removeAllTextGroup() {
        for(let groupName in this._TextGMap) {
            this.removeTextGroup(groupName);
        }
    }

    // SVG 리턴
    getSvg() {
        return this._Svg;
    }

    setWidth(width) {
        this.width = width;
        return this;
    }

    setHeight(height) {
        this.height = height;
        return this;
    }

    setMapScale(mapScale) {
        this.mapScale = mapScale;
        return this;
    }

    setCenter(center) {
        this.center = center;
        return this;
    }

    setViewScale(viewScale) {
        this.viewScale = viewScale;
        return this;
    }

    setGeoJsonUrl(geoJsonUrl) {
        this.geoJsonUrl = geoJsonUrl;
        return this;
    }

    setKeyPropNm(keyPropNm) {
        this.keyPropNm = keyPropNm;
        return this;
    }

    setNamePropNm(namePropNm) {
        this.namePropNm = namePropNm;
        return this;
    }

    setMapDrawCompletedHandler(mapDrawCompletedHandler) {
        this.mapDrawCompletedHandler = mapDrawCompletedHandler;
        return this;
    }

    setPathClickHandler(pathClickHandler) {
        this.pathClickHandler = pathClickHandler;
        return this;
    }

    // 외곽선 색상 지정
    setPathStrokeColor(pathStrokeColor) {
        this.pathStrokeColor = pathStrokeColor;
        return this;
    }

    // 투명도 변경
    setPathOpacity(pathOpacity) {
        this.pathOpacity = pathOpacity;
        return this;
    }

    // 외곽선 굵기 지정
    setPathStrokeWidth(pathStrokeWidth) {
        this.pathStrokeWidth = pathStrokeWidth;
        return this;
    }

    // 해당 영역의 색상을 변경한다.
    changePathColor(key, color) {
        let realKey = "p_" + key;
        if(typeof this._PathMap[realKey] !== 'undefined') {
            this._PathMap[realKey].setAttribute("fill", color);
        }
    }

    // 모든 영역의 색상을 변경한다.
    changeAllPathColor (color) {
        for(let key in this._PathMap) {
            if(typeof this._PathMap[key] !== 'undefined') {
                this._PathMap[key].setAttribute("fill", color);
            }
        }
    }

    // 모든 영역의 색상 초기화
    changeAllPathDefaultColor() {
        this.changeAllPathColor(this.pathDefaultColor);
    }

    // 기본 텍스트(지역명) 표시 여부
    isDisplayDefaultText(isDisplay) {
        if(isDisplay) {
            this._DefaultTextG.style("display", "");
        } else {
            this._DefaultTextG.style("display", "none");
        }
    }

    setDisplayDefaultTextDy(em) {
        this._DefaultTextG.selectAll("text").attr("dy", em + "em")
    }

    isDisplayValueText(isDisplay) {
        if(isDisplay) {
            this._ValueTextG.style("display", "");
        } else {
            this._ValueTextG.style("display", "none");
        }
    }

    changeValueText(key, text) {
        let realKey = "v_t_" + key;

        if(typeof this._ValueTextMap[realKey] !== 'undefined') {
            this._ValueTextMap[realKey].innerHTML = unescape(text);
        }
    }

    isDisplayPath(isDisplay) {
        if(isDisplay) {
            this._PathG.style("display", "");
        } else {
            this._PathG.style("display", "none");
        }
    }

}
